import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getLearningPathProgress } from "../../services";

const ENDPOINT_URL = "/api/v2/participant/learning-path/progress";

export const useLearningPathProgress = () => {
  return useQuery({
    queryKey: [ENDPOINT_URL],
    queryFn: () => getLearningPathProgress(),
  });
};

export const useUpdateLearningPathProgress = () => {
  const queryClient = useQueryClient();
  const invalidateCache = () => {
    queryClient.invalidateQueries([ENDPOINT_URL]);
  };
  return {
    invalidateCache,
  };
};
